var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransformer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "200px",
    viewBox: "0 0 89 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u53D8\u538B\u5668\u56DE\u8DEF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3076-\\u4E00\\u6B21\\u8FDB\\u7EBF\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-446.000000, -200.000000)",
    id: "\\u53D8\\u538B\\u5668\\u56DE\\u8DEF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(447.000000, 201.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 14,
    y: 32.5,
    width: 73,
    height: 140
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-39",
    transform: "translate(43.500000, 79.000000)",
    stroke: "#52C41A",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-8",
    points: "0 0 37 0 37 74.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    transform: "translate(37.000000, 59.500000) rotate(90.000000) translate(-37.000000, -59.500000) ",
    x: 22,
    y: 54,
    width: 30,
    height: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27\\u5907\\u4EFD-2",
    transform: "translate(30.500000, 75.500000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 0.5,
    x2: 6.5,
    y2: 10.5,
    id: "\\u76F4\\u7EBF-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 11.5,
    x2: 12.5,
    y2: 11.5,
    id: "\\u76F4\\u7EBF-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 14.5,
    x2: 10.5,
    y2: 14.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 17.5,
    x2: 8.5,
    y2: 17.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-39",
    opacity: 0,
    transform: "translate(21.750000, 125.750000) scale(-1, 1) translate(-21.750000, -125.750000) translate(0.000000, 79.000000)",
    stroke: "#979797",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-8",
    points: "0 0 37 0 37 74.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    transform: "translate(37.000000, 59.500000) rotate(90.000000) translate(-37.000000, -59.500000) ",
    x: 22,
    y: 54,
    width: 30,
    height: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27\\u5907\\u4EFD-2",
    transform: "translate(30.500000, 75.500000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 0.5,
    x2: 6.5,
    y2: 10.5,
    id: "\\u76F4\\u7EBF-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 11.5,
    x2: 12.5,
    y2: 11.5,
    id: "\\u76F4\\u7EBF-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 14.5,
    x2: 10.5,
    y2: 14.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 17.5,
    x2: 8.5,
    y2: 17.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-23",
    transform: "translate(24.000000, 32.500000)",
    stroke: "#E64242",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 19.5,
    cy: 19.5,
    r: 18.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-5",
    points: "19.5 12 14 21 25 21"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 43.5,
    y1: 2.14758766e-15,
    x2: 43.5,
    y2: 32,
    id: "\\u76F4\\u7EBF",
    stroke: "#E64242",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.5,
    y1: 99,
    x2: 43.5,
    y2: 197,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-5",
    stroke: "#E64242",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-22",
    transform: "translate(24.000000, 59.500000)",
    stroke: "#E64242",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-8",
    cx: 19.5,
    cy: 19.5,
    r: 18.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-20",
    transform: "translate(13.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-6",
    points: "-1.16573418e-16 5.5 6.5 5.5 11 9.15933995e-15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 5.5,
    x2: 11,
    y2: 11,
    id: "\\u8DEF\\u5F84-7"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformer);
export default __webpack_public_path__ + "static/media/transformer.644ba113764343e86708846983feaffe.svg";
export { ForwardRef as ReactComponent };